var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('section', {
    staticClass: "login-form section m-0 pb-0"
  }, [_c('div', {
    staticClass: "container-fluid p-0"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    class: _vm.contentClass
  }, [_c('div', {
    staticClass: "content row mx-0 form-fields d-flex justify-content-center text-display",
    style: {
      minHeight: `${_vm.loginContainerHeight}px`
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 col-xl-4 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start align-items-center"
  }, [_c('div', {
    staticClass: "title-defined h-auto d-flex flex-column justify-content-center align-items-center align-items-lg-start align-items-xl-start mb-5"
  }, [_c('div', {
    staticClass: "w-100 h-auto title-text text-center text-lg-left text-xl-left"
  }, [_vm._v(" Verify Email ")]), _c('div', {
    staticClass: "description-text text-center text-lg-left text-xl-left px-4 px-md-0 px-lg-0 px-xl-0",
    domProps: {
      "innerHTML": _vm._s(`We sent a verification code to ${_vm.email}. Please check your inbox and enter the six digit code to verify your account.`)
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-8 col-xl-8 p-0 pl-0 pl-lg-5 pl-xl-5 border-class d-flex flex-column justify-content-center align-items-center align-items-lg-start align-items-xl-start verification-code",
    class: _vm.inputEntryClass
  }, [_c('div', {
    staticClass: "w-auto d-flex flex-column align-items-center align-items-md-start align-items-lg-start align-items-xl-start"
  }, [_c('p', {
    staticClass: "verification-text m-0"
  }, [_vm._v(" Verification Code ")]), _c('img', {
    staticStyle: {
      "width": "57%"
    },
    attrs: {
      "src": require('@assetsImages/icon-image/verification.svg'),
      "alt": "Email Verification"
    }
  })]), _c('div', {
    staticClass: "container-fluid p-0 m-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "row m-0 h-100 input-code-row"
  }, [_c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry1,
      expression: "codeEntry1"
    }],
    ref: "inputCode1",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry1
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry1 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])]), _c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry2,
      expression: "codeEntry2"
    }],
    ref: "inputCode2",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry2
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry2 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])]), _c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry3,
      expression: "codeEntry3"
    }],
    ref: "inputCode3",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry3
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry3 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])]), _c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry4,
      expression: "codeEntry4"
    }],
    ref: "inputCode4",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry4
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry4 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])]), _c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry5,
      expression: "codeEntry5"
    }],
    ref: "inputCode5",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry5
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry5 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])]), _c('div', {
    staticClass: "col-2 p-0 px-1 px-sm-0 px-md-0 px-lg-0 px-xl-0 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "input-code-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.codeEntry6,
      expression: "codeEntry6"
    }],
    ref: "inputCode6",
    staticClass: "input-code",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.codeEntry6
    },
    on: {
      "keypress": _vm.inputCodeEntry,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.codeEntry6 = $event.target.value;
      }, _vm.inputCodeEntry],
      "paste": _vm.pasteCodeEntry
    }
  })])])])]), _c('div', {
    staticClass: "w-auto"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.sendEmailVerificationCode.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "resend-code-link",
    style: {
      color: _vm.isResendCodeLinkInactive || _vm.verified ? '#696969' : _vm.primaryWhiteColor
    }
  }, [_vm._v(" " + _vm._s(_vm.isResendCodeLinkInactive && !_vm.verified ? `Resend Code (${_vm.resendCodeTimeInterval}s)` : `Resend Code`) + " ")])])]), _c('div', {
    staticClass: "d-flex flex-column flex-lg-row flex-xl-row justify-content-center justify-content-lg-start justify-content-xl-start item-btn-gap"
  }, [_c('b-button', {
    staticClass: "item-btn",
    attrs: {
      "size": "sm",
      "disabled": _vm.verified || _vm.code.length !== 6
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Submit Code ")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('b-button', {
    staticClass: "item-btn",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        '';
      }
    }
  }, [_vm._v("Back To Login ")])], 1)], 1), _c('div', {
    staticClass: "container-fluid p-0 m-0",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "row m-0 h-100"
  }, [_vm.hasResponseError || _vm.isCodeResent ? _c('div', {
    staticClass: "col-12 p-0 m-0 text-center text-lg-left text-xl-left",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Rajdhani"
    }
  }, [_vm.isCodeResent ? _c('strong', {
    staticClass: "m-0",
    style: {
      color: _vm.primaryWhiteColor
    }
  }, [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]) : _c('strong', {
    style: {
      color: _vm.invalidFormLabelColor
    }
  }, [_vm._v(" " + _vm._s(_vm.resendCodeErrorMsg) + " ")])]) : _vm._e()])])])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }